import { render, staticRenderFns } from "./CodingRequestProSpecialtiesModal.vue?vue&type=template&id=0b92893a&scoped=true&"
import script from "./CodingRequestProSpecialtiesModal.vue?vue&type=script&lang=js&"
export * from "./CodingRequestProSpecialtiesModal.vue?vue&type=script&lang=js&"
import style0 from "./CodingRequestProSpecialtiesModal.vue?vue&type=style&index=0&id=0b92893a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92893a",
  null
  
)

export default component.exports